import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router";
import { get } from "lodash";
import { Segment, Grid, Container } from "semantic-ui-react";
import { resetSelection } from "marketing_portal/actions/resetAction";
import { withRouter } from "../../../shared/helpers/withRouter";
import "./pageFooter.scss";

class PageFooter extends React.Component {
  static propTypes = {
    layoutScope: PropTypes.string,
    dataPrivacyStatementUri: PropTypes.string,
    account: PropTypes.object
  };

  render() {
    const { account, layoutScope, dataPrivacyStatementUri } = this.props;
    if (layoutScope !== "login") {
      return (
        <Segment
          data-component="pageFooter"
          inverted
          vertical
          className="footer"
        >
          <Container>
            <Grid stackable className="equal height">
              <Grid.Column width={8} verticalAlign="middle">
                <Link to="/imprint" className="imprint-link">
                  <FormattedMessage id="buyerPortal.footer.imprint" />
                </Link>
                {dataPrivacyStatementUri && (
                  <a className="privacy-link" href={dataPrivacyStatementUri}>
                    <FormattedMessage id="buyerPortal.footer.dataPrivacyStatement" />
                  </a>
                )}
                <a role="button" onClick={resetSelection}>
                  <FormattedMessage id="meta.actions.reset" />
                </a>
              </Grid.Column>
              <Grid.Column width={8} textAlign="right" verticalAlign="middle">
                Copyright &copy; {new Date().getFullYear()} -{" "}
                {account && account.name}
              </Grid.Column>
            </Grid>
          </Container>
        </Segment>
      );
    }
    return (
      <div style={{ textAlign: "center" }} data-component="pageFooter">
        <Link to={get(account, "name") ? "/" : "/users/login"}>Home</Link>|
        <Link to="/imprint" className="imprint-link">
          <FormattedMessage id="buyerPortal.footer.imprint" />
        </Link>
        |
        {dataPrivacyStatementUri && (
          <a href={dataPrivacyStatementUri}>
            <FormattedMessage id="buyerPortal.footer.dataPrivacyStatement" />
          </a>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const layoutScope = props.routes.reduce((accu, r) => {
    return r.layoutScope;
  });

  return {
    account: get(state, "account.account"),
    dataPrivacyStatementUri: get(
      state,
      "branding.account.data_privacy_statement_url"
    ),
    layoutScope
  };
};

export default withRouter(connect(mapStateToProps)(PageFooter));
